module.exports = __webpack_public_path__ + "static/media/siteLogo.9caab114.svg";